













import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class ProfileInfo extends Vue {
  @Prop({ default: '' }) header;
  @Prop({ default: '' }) text;
}
